import { Fragment, useState } from "react";
import { Grid, MenuItem, Typography, Box } from "@mui/material";
import { TextField, SelectField, LoadingButton } from "../../../../components";
import { useAxios } from "../../../../hooks";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const PRIMARY_COLOR = "rgb(57, 54, 239)";

function Form({ formik, eventList, badgeList, setBadgeList }) {
  const axiosApi = useAxios({ baseURL: "mox_api_2" });
  const [loading, setLoading] = useState(false);

  function handleBadge(e) {
    formik.setFieldValue("eventID", e.target.value);
    axiosApi({
      url: "admin/badge/get-entity-badges?entity_id=" + e.target.value,
      method: "GET",
      disableRedirect: true,
    })
      .then((response) => {
        if (response.status) {
          setBadgeList(response.data || []);
        }
      })
      .catch((error) => {
        console.error("Error in fetching events list", error);
      });
  }

  return (
    <Box
      sx={{
        border: `1px solid ${PRIMARY_COLOR}`,
        borderRadius: "12px",
        padding: "30px 25px",
        boxShadow: "0px 2px 10px rgba(0,0,0,0.05)",
        backgroundColor: "#fff",
        height: "100%",
      }}
    >
      {/* Form Title */}
      <Typography
        variant="h6"
        align="center"
        gutterBottom
        sx={{
          fontWeight: "bold",
          color: PRIMARY_COLOR,
          textTransform: "uppercase",
        }}
      >
        Add Booking
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Select Your Event"
            placeholder="Select Your Event"
            name="eventID"
            formikProps={formik}
            select
            required
            onChange={handleBadge}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
              },
            }}
          >
            {eventList.map((item) => (
              <MenuItem key={item.entity_id} value={item.entity_id}>
                {item.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12}>
          <TextField
            name="visitorData[0].first_name"
            placeholder="First Name"
            formikProps={formik}
            fullWidth
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            name="visitorData[0].last_name"
            placeholder="Last Name"
            formikProps={formik}
            fullWidth
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            name="visitorData[0].gender"
            placeholder="Select Gender"
            label="Select Gender"
            formikProps={formik}
            select
            required
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
              },
            }}
          >
            {[
              { id: "Male", name: "Male" },
              { id: "Female", name: "Female" },
            ].map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12}>
          <TextField
            name="visitorData[0].phone_number"
            placeholder="Phone Number"
            formikProps={formik}
            fullWidth
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            name="visitorData[0].email_id"
            placeholder="Email"
            formikProps={formik}
            fullWidth
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Select Your Badge"
            placeholder="Select Your Badge"
            name="badgeID"
            formikProps={formik}
            select
            required
            disabled={badgeList.length === 0}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
              },
            }}
          >
            {badgeList.map((item) => (
              <MenuItem key={item._id} value={item._id}>
                {item.badge_name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>

      {/* Submit Button */}
      <Box mt={3}>
        <LoadingButton
          loading={loading}
          type="submit"
          fullWidth
          sx={{
            fontWeight: 700,
            backgroundColor: PRIMARY_COLOR,
            color: "#fff",
            borderRadius: "10px",
            padding: "12px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(57, 54, 239, 0.9)",
            },
            marginBottom: "15px",
          }}
          style={{ marginBottom: "15px" }}
        >
          <ArrowForwardIcon />
        </LoadingButton>
      </Box>
    </Box>
  );
}

export default Form;
